import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { push, reconstructRoute } from 'Helper/routeHelpers'

const CONTEXT_SHORT_NAME = {
  nurseDashboard: 'dashboard',
  patientDisplay: 'patient',
  adminDisplay: 'admin'
}

const LinkItem = ({ type, item, prefix, context }) => {
  const dispatch = useDispatch()
  const params = useSelector(state => state.router.match.params)
  const clickHandler = e => {
    e.preventDefault()
    const newRouteParams = {}
    newRouteParams[type] = item.path
    let route = `${prefix}/${type}/${item.path}`
    route = reconstructRoute(params, newRouteParams, route)
    push(route)
    if (type === 'screen') {
      dispatch({ type: 'SET_VIEW', screen: item })
    }
  }

  const shortContext = CONTEXT_SHORT_NAME[context] || context
  const elementId = shortContext ? `${shortContext}-${type}-${item.path}` : item.path

  return (
    <li>
      <a
        id={elementId}
        data-cy={elementId}
        role="button"
        aria-label={`${item.name} ${type} link`}
        onClick={clickHandler}
      >
        {item.name}
      </a>
    </li>
  )
}

LinkItem.propTypes = {
  item: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
  context: PropTypes.string
}

export default LinkItem
